const ismIsyarah = [
  [
    [
      { ar: 'لِلْقَرِيبِ', en: 'Near', ms: 'Dekat' },
      { ar: 'اَلْمُذَكَّرُ', en: 'Male', ms: 'Lelaki' },
      { ar: 'اَلْمُؤَنَّثُ', en: 'Female', ms: 'Perempuan' },
    ],
    [
      { ar: 'اَلْمُفْرَدُ', en: 'One', ms: 'Satu' },
      { ar: 'هَذَا', en: 'This', ms: 'Ini' },
      { ar: 'هَذِهِ', en: 'This', ms: 'Ini' },
    ],
    [
      { ar: 'اَلْمُثَنَّى', en: 'Two', ms: 'Dua' },
      { ar: 'هَذَانِ', en: 'This', ms: 'Ini' },
      { ar: 'هَاتَانِ', en: 'This', ms: 'Ini' },
    ],
    [
      { ar: 'اَلْجَمْعُ', en: 'Many', ms: 'Banyak/Ramai' },
      { ar: 'هَؤُلَاءِ', en: 'This', ms: 'Ini' },
      { ar: 'هَؤُلَاءِ', en: 'This', ms: 'Ini' },
    ],
  ],
  [
    [
      { ar: 'لِلْبَعِيْدِ', en: 'Far', ms: 'Jauh' },
      { ar: 'اَلْمُذَكَّرُ', en: 'Male', ms: 'Lelaki' },
      { ar: 'اَلْمُؤَنَّثُ', en: 'Female', ms: 'Perempuan' },
    ],
    [
      { ar: 'اَلْمُفْرَدُ', en: 'One', ms: 'Satu' },
      { ar: 'ذَلِكَ', en: 'That', ms: 'Itu' },
      { ar: 'تِلْكَ', en: 'That', ms: 'Itu' },
    ],
    [
      { ar: 'اَلْمُثَنَّى', en: 'Two', ms: 'Dua' },
      { ar: 'ذَانِكَ', en: 'That', ms: 'Itu' },
      { ar: 'تَانِكَ', en: 'That', ms: 'Itu' },
    ],
    [
      { ar: 'اَلْجَمْعُ', en: 'Many', ms: 'Banyak/Ramai' },
      { ar: 'أُولَئِكَ', en: 'That', ms: 'Itu' },
      { ar: 'أُولَئِكَ', en: 'That', ms: 'Itu' },
    ],
  ],
];

export default ismIsyarah;
